export default {
  name: 'input_tel',
  component_path: 'modules/procedures/blocks/BlockInputTel'
}